import { FileTreeFileKind, FileTreeFolderNode, FileTreeNode } from '../types';

export function isFileTreeFolder(node: FileTreeNode): node is FileTreeFolderNode {
  return node.kind === 'folder';
}

export function collectFilePaths(tree: FileTreeFolderNode): string[] {
  const paths: string[] = [];
  const walk = (node: FileTreeNode) => {
    if (node.kind === 'file') {
      paths.push(node.path);
      return;
    }
    for (const child of node.children) {
      walk(child);
    }
  };
  for (const child of tree.children) {
    walk(child);
  }
  return paths;
}

export function defaultExpandedFolders(tree: FileTreeFolderNode): string[] {
  const expanded = new Set<string>(['/']);
  for (const child of tree.children) {
    if (child.kind === 'folder') {
      expanded.add(child.path);
    }
  }
  return Array.from(expanded);
}

export function fileKindLabelKey(fileKind: FileTreeFileKind): string {
  switch (fileKind) {
    case 'settings':
      return 'files.kindSettings';
    case 'layout':
      return 'files.kindLayout';
    case 'signals':
      return 'files.kindSignals';
    case 'flow':
      return 'files.kindFlow';
    default:
      return 'files.kindFile';
  }
}
